/**
 * 表格列宽管理混入
 * 用于保存和读取表格列宽设置
 */
import axios from 'axios';

export const tableColumnWidthMixin = {
  data() {
    return {
      // 列宽存储的localStorage键名
      columnWidthStorageKey: 'table_column_widths',
      // 表格列宽设置 - 将从后端API获取
      columnWidths: {}
    };
  },
  mounted() {
    // 组件挂载时从后端获取默认列宽
    this.fetchDefaultColumnWidths();
  },
  methods: {
    /**
     * 从后端API获取默认列宽设置
     */
    async fetchDefaultColumnWidths() {
      try {
        const response = await axios.get('api/table_column_widths_default/');
        if (response.data.success) {
          this.columnWidths = response.data.defaultWidths;
          console.log('成功从后端获取默认列宽:', this.columnWidths);
          // 获取默认值后，加载用户自定义的列宽
          this.loadColumnWidths();
        }
      } catch (error) {
        console.error('获取默认列宽失败:', error);
        // 如果API调用失败，使用硬编码的默认值
        this.columnWidths={"学校名":118,"年份":29,"批次":29,"专业名称":80,"最高分":29,"最高位次":80,"最低分":29,"最低位次":80,"冲稳保":29,"专业类":80,"专业备注":80,"位差":64,"计划数":29,"往年数":29,"扩缩招":40,"线差":50,"自线差":29,"学校代码":29,"生源地":29,"科类":29,"再选科目":29,"专业组":29,"专业代码":29,"学校省份":29,"城市":29,"学校性质":29,"汇总标签":29,"排序列":120,"中外合作":29,"本科提前批":29,"校区":29,"定向":29,"师范":29,"嵌入式培养":29,"联合培养":29,"本硕或本博":29,"其他":29,"ID":29}
        ;
        console.log('使用硬编码的默认列宽');
        // 硬编码默认值后，也加载用户自定义的列宽
        this.loadColumnWidths();
      }
    },

    /**
     * 从localStorage加载列宽设置
     */
    loadColumnWidths() {
      try {
        const storedWidths = localStorage.getItem(this.columnWidthStorageKey);
        if (storedWidths) {
          const parsedWidths = JSON.parse(storedWidths);
          // 合并默认值和存储的值，存储的值优先级更高
          this.columnWidths = { ...this.columnWidths, ...parsedWidths };
          // console.log('成功加载列宽设置:', this.columnWidths);
          // 列宽加载成功后，应用列宽设置
          this.$nextTick(() => {
            this.applyColumnWidths();
          });
          return true;
        }
      } catch (error) {
        console.error('加载列宽设置失败:', error);
      }
      // 如果没有存储值，使用默认值并应用
      this.$nextTick(() => {
        this.applyColumnWidths();
      });
      return false;
    },
    
    /**
     * 保存列宽设置到localStorage
     */
    saveColumnWidths() {
      try {
        console.log('尝试保存到localStorage，键名:', this.columnWidthStorageKey);
        console.log('要保存的数据:', this.columnWidths);
        
        // 确保数据是有效的
        if (Object.keys(this.columnWidths).length === 0) {
          console.warn('没有要保存的列宽数据');
          return false;
        }
        
        // 执行保存
        localStorage.setItem(this.columnWidthStorageKey, JSON.stringify(this.columnWidths));
        
        // 立即验证保存是否成功
        const savedData = localStorage.getItem(this.columnWidthStorageKey);
        console.log('保存后从localStorage读取:', savedData);
        
        // 解析保存的数据，确认每个列宽都被正确保存
        const parsedData = JSON.parse(savedData);
        console.log('解析后的数据:', parsedData);
        
        // 检查是否存在$message对象，如果存在则显示提示
        if (this.$message) {
          this.$message.success('列宽设置已保存');
        } else {
          console.log('列宽设置已保存');
        }
        return true;
      } catch (error) {
        console.error('保存列宽设置失败:', error);
        // 检查是否存在$message对象，如果存在则显示提示
        if (this.$message) {
          this.$message.error('列宽设置保存失败');
        }
        return false;
      }
    },
    
    /**
     * 更新单个列的宽度
     * @param {Object} { prop, width } - 列属性和宽度
     */
    updateColumnWidth({ prop, width }) {
      this.columnWidths[prop] = width;
    },
    
    /**
     * 获取列的宽度，如果有保存的宽度则返回保存的，否则返回默认值
     * @param {String} prop - 列属性名
     * @param {Number} defaultWidth - 默认宽度
     * @returns {Number} - 列宽度
     */
    getColumnWidth(prop, defaultWidth = 120) {
      return this.columnWidths[prop] || defaultWidth;
    },
    
    /**
     * 处理列宽改变事件
     * @param {Event} column - 列对象
     */
    // 修改 handleColumnWidthChange 方法
    handleColumnWidthChange(column) {
      // 尝试获取列的标签文本作为键
      const key = column.label || column.property;
      this.updateColumnWidth({
        prop: key,
        width: column.width
      });
      console.log(`保存列宽: ${key} = ${column.width}px`);
    },
    
    /**
     * 应用列宽设置到表格
     */
    applyColumnWidths() {
      try {
        // console.log('应用保存的列宽设置');
        
        // 等待DOM更新
        this.$nextTick(() => {
          // 获取所有表格实例
          const tables = document.querySelectorAll('.el-table');
          
          tables.forEach(table => {
            // 直接操作DOM元素设置宽度
            const headerCells = table.querySelectorAll('.el-table__header th');
            
            headerCells.forEach(th => {
              const cell = th.querySelector('.cell');
              if (!cell) return;
              
              // 获取列标题文本
              const cellText = cell.textContent.trim();
              
              // 查找保存的宽度 - 添加调试日志
              const savedWidth = this.columnWidths[cellText];
              // console.log(`查找保存的列宽: ${cellText} = ${savedWidth ? savedWidth + 'px' : '未找到'}`);
              
              if (savedWidth && savedWidth >= 1 && savedWidth <= 2000) {
                // console.log(`应用保存的列宽: ${cellText} = ${savedWidth}px`);
                
                // 强制设置宽度相关样式
                th.style.width = `${savedWidth}px`;
                th.style.minWidth = `${savedWidth}px`;
                th.style.maxWidth = `${savedWidth}px`;
                
                // 同时设置对应的body单元格宽度
                const index = Array.from(headerCells).indexOf(th);
                const bodyCells = table.querySelectorAll(`.el-table__body td:nth-child(${index + 1})`);
                bodyCells.forEach(bodyCell => {
                  bodyCell.style.width = `${savedWidth}px`;
                  bodyCell.style.minWidth = `${savedWidth}px`;
                  bodyCell.style.maxWidth = `${savedWidth}px`;
                });
              }
            });
            
            // 如果是Vue组件，强制更新
            if (table.__vue__) {
              // 强制更新表格布局
              if (table.__vue__.doLayout) {
                table.__vue__.doLayout();
              }
              
              // 尝试强制组件更新
              if (typeof table.__vue__.$forceUpdate === 'function') {
                table.__vue__.$forceUpdate();
              }
            }
          });
          
          // 强制浏览器重绘
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 200);
        });
        
      } catch (error) {
        console.error('应用列宽设置失败:', error);
      }
    }
  }
};